import type { TFunction } from "i18next";
import { ApiError } from "@/lib/api-client";

export const NO_APPROVED_RECIPIENT_CODE = "NO_APPROVED_RECIPIENT";

export function createOrderErrorMessage(error: unknown, t: TFunction): string {
  if (error instanceof ApiError && error.code === NO_APPROVED_RECIPIENT_CODE) {
    return t(
      "opportunities.scripts.sendDialog.noApprovedEmail",
      "Vendor has no approved contact email — contact support",
    );
  }
  return t("common.error.generic", "Something went wrong. Please try again.");
}

